__turbopack_context__.v({
  "root": "switch-filter-module-scss-module__9RXugq__root",
  "title": "switch-filter-module-scss-module__9RXugq__title",
});
